module.exports = "<p>\n  ask-wazzers works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/ask-wazzers/ask-wazzers.component.html
// module id = ../../../../../src/app/ask-wazzers/ask-wazzers.component.html
// module chunks = main